import React from 'react';

const StatusBadge = ({ status, type = 'default', className = '' }) => {
  const getStatusStyles = () => {
    const baseStyles = 'inline-flex px-2 py-1 text-xs font-medium rounded-full';
    
    switch (type) {
      case 'user':
        switch (status?.toLowerCase()) {
          case 'active':
            return `${baseStyles} bg-success-100 text-success-800`;
          case 'suspended':
          case 'inactive':
            return `${baseStyles} bg-danger-100 text-danger-800`;
          case 'pending':
            return `${baseStyles} bg-warning-100 text-warning-800`;
          default:
            return `${baseStyles} bg-gray-100 text-gray-800`;
        }
      
      case 'platform':
        switch (status?.toLowerCase()) {
          case 'operational':
            return `${baseStyles} bg-success-100 text-success-800`;
          case 'degraded':
            return `${baseStyles} bg-warning-100 text-warning-800`;
          case 'maintenance':
            return `${baseStyles} bg-primary-100 text-primary-800`;
          case 'outage':
            return `${baseStyles} bg-danger-100 text-danger-800`;
          default:
            return `${baseStyles} bg-gray-100 text-gray-800`;
        }
      
      case 'ticket':
        switch (status?.toLowerCase()) {
          case 'open':
            return `${baseStyles} bg-danger-100 text-danger-800`;
          case 'in-progress':
          case 'in_progress':
            return `${baseStyles} bg-warning-100 text-warning-800`;
          case 'resolved':
          case 'closed':
            return `${baseStyles} bg-success-100 text-success-800`;
          default:
            return `${baseStyles} bg-gray-100 text-gray-800`;
        }
      
      case 'priority':
        switch (status?.toLowerCase()) {
          case 'high':
          case 'critical':
            return `${baseStyles} bg-danger-100 text-danger-800`;
          case 'medium':
            return `${baseStyles} bg-warning-100 text-warning-800`;
          case 'low':
            return `${baseStyles} bg-success-100 text-success-800`;
          default:
            return `${baseStyles} bg-gray-100 text-gray-800`;
        }
      
      case 'plan':
        switch (status?.toLowerCase()) {
          case 'enterprise':
            return `${baseStyles} bg-admin-100 text-admin-800`;
          case 'professional':
          case 'pro':
            return `${baseStyles} bg-primary-100 text-primary-800`;
          case 'basic':
          case 'free':
            return `${baseStyles} bg-gray-100 text-gray-800`;
          default:
            return `${baseStyles} bg-gray-100 text-gray-800`;
        }
      
      case 'health':
        switch (status?.toLowerCase()) {
          case 'healthy':
          case 'good':
            return `${baseStyles} bg-success-100 text-success-800`;
          case 'warning':
            return `${baseStyles} bg-warning-100 text-warning-800`;
          case 'critical':
          case 'error':
            return `${baseStyles} bg-danger-100 text-danger-800`;
          default:
            return `${baseStyles} bg-gray-100 text-gray-800`;
        }
      
      default:
        return `${baseStyles} bg-gray-100 text-gray-800`;
    }
  };

  return (
    <span className={`${getStatusStyles()} ${className}`}>
      {status}
    </span>
  );
};

export default StatusBadge;
